import React, { useState, useEffect } from "react";
import { Row, Col, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import DateRange from "./date_range";

const AnalyticsSection = ({
    title,
    dateRange,
    onDateChange,
    reportLink,
    children,
    isQuickOverview = false,
    heading,
    disabledLabels,
    hideDateRange = false,
    hideReportLink = false,
    className = "p-3"
}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 768;
    const reportButtonStyle = {
        whiteSpace: 'nowrap',
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '42px',
        padding: '0 14px',
        border: '1px solid #D5C5E7',
        borderRadius: '0.5rem',
        color: '#5E07E6',
        textDecoration: 'none',
        backgroundColor: '#fff'
    };

    return (
        <CardBody>
            <Row className={`analytics-section-header ${className}`}>
                <Col md={hideReportLink && hideDateRange ? 6 : hideReportLink || hideDateRange ? 6 : 6} xs={12} style={isMobile ? { textAlign: 'left', marginBottom: '15px' } : {display: 'flex', justifyContent: 'left', alignItems: 'center'}}>
                    <h4 className="fs-4">{title}</h4>
                </Col>
                <Col md={6} xs={12} style={isMobile ? { display: 'flex', justifyContent: 'left', marginBottom: '15px' } : { textAlign: 'right' }}>
                    <div style={{ display: 'inline-flex', gap: '10px', justifyContent: isMobile ? 'left' : 'right', alignItems: 'center' }}>
                        {!hideDateRange && dateRange && (
                            <DateRange
                                dateRange={dateRange}
                                onChange={onDateChange}
                                selectedLabel={dateRange[0]?.label}
                                title={heading}
                                disabledLabels={disabledLabels}
                            />
                        )}
                        {!hideReportLink && <Link to={reportLink} className="fs--1" style={reportButtonStyle}>View Full Report</Link>}
                    </div>
                </Col>
            </Row>
            {children}
        </CardBody>
    );
};

export default AnalyticsSection;
